module.exports = __webpack_public_path__ + "media/img/specialize/mobile/item3-51bfbfbe64b7c9d8facf57b1453a8713.svg";